<div class="row person">
    <div class="col-sm-4 person-col">
        <div class="view-item">
            <div class="row justify-content-between">
                <h5>Propriétés</h5>
                <button class="btn btn-outline-info">Enregistrer</button>
            </div>
            <div class="form-group row">
                <label for="civilite" class="col-sm-4">Civilité :</label>
                <input type="text" id="civilite" name="civilite" class="form-control col-sm-8" value="Monsieur">
            </div>
            <div class="form-group row">
                <label for="nom" class="col-sm-4">Nom :</label>
                <input type="text" id="nom" name="nom" class="form-control col-sm-8" value="ABADIE">
            </div>
            <div class="form-group row">
                <label for="prenom" class="col-sm-4">Prénom :</label>
                <input type="text" id="prenom" name="prenom" class="form-control col-sm-8" value="Philippe">
            </div>
        </div>
        <div class="view-item">
            <div class="row justify-content-between">
                <h5>Téléphone(s)</h5>
                <button class="btn btn-outline-info">Ajouter un nouveau numéro</button>
            </div>

            <table class="table table-sm table-striped">
                <thead>
                    <th (click)="sortby('nom_telephone')" scope="col">Nom de la personne</th>
                    <th (click)="sortby('numero_telephone')" scope="col">Numéro</th>
                </thead>
                <tbody>
                    <!--Début boucle ligne -->
                    <tr>
                        <td>Pizzeria</td>
                        <td>05 59 67 11 47</td>
                    </tr>
                    <!--Fin boucle ligne-->
                    <tr>
                        <td>Port Mme ABADIE</td>
                        <td>06 23 09 22 29</td>
                    </tr>
                    <tr>
                        <td>Port Mr ABADIE</td>
                        <td>07 86 59 68 85</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="view-item w-100">
            <div class="row justify-content-between">
                <h5>e-Mail(s)</h5>
                <button class="btn btn-outline-info">Ajouter une nouvelle adresse e-Mail</button>
            </div>
            <table class="table table-sm table-striped">
                <thead>
                    <th (click)="sortby('nom_mail')">Nom adresse</th>
                    <th (click)="sortby('adresse_mail')">Adresse e-mail</th>
                </thead>
                <tbody>
                    <tr>
                        <td>Mail societe</td>
                        <td>ileamano@yahoo.fr</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="col-sm-8 view-item">
        <h5>Installations</h5>
        <p class="w-100"><span class="material-icons">flag</span> (166) SAN PIETRO Orthez</p>
    </div>
    <div class="w-100 view-item">
        <div class="row justify-content-between">
            <h5>Adresse(s)</h5>
            <button class="btn btn-outline-info">Ajouter une nouvelle adresse</button>
        </div>
        <div class="table-responsive">
            <table class="table table-sm table-striped">
                <thead>
                    <th (click)="sortby('type_adresse')" scope="col">Type adresse</th>
                    <th (click)="sortby('destinataire_adresse')" scope="col">Destinataire</th>
                    <th (click)="sortby('adresse')" scope="col">Adresse</th>
                    <th (click)="sortby('complement_adresse')" scope="col">Complément</th>
                    <th (click)="sortby('codepostal_adresse')" scope="col">Code Postal</th>
                    <th (click)="sortby('ville_adresse')" scope="col">Ville</th>
                    <th (click)="sortby('pays_adresse')" scope="col">Pays</th>
                    <th scope="col" class="material-icons">edit</th>
                    <th scope="col" class="material-icons">clear</th>
                </thead>
                <tbody>
                    <tr>
                        <td>TNT</td>
                        <td></td>
                        <td>670 avenue du docteur dhers</td>
                        <td></td>
                        <td>64300</td>
                        <td>ORTHEZ</td>
                        <td></td>
                        <td class="material-icons">edit</td>
                        <td class="material-icons">clear</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="col-sm-4 view-item">
        <div class="row justify-content-between">
            <h5>Comptes utilisateur</h5>
            <button class="btn btn-outline-info">Créer un nouveau compte</button>
        </div>
        <table class="table table-sm table-striped">
            <thead>
                <th (click)="sortby('nom_utilisateur')">Nom d'utilisateur</th>
                <th (click)="sortby('type_utilisateur')">Type de compte</th>
                <th (click)="sortby('derniereco_utilisateur')">Dernière connexion</th>
            </thead>
        </table>
    </div>
    <div class="col-sm-4 view-item">
        <h5>Société(s)</h5>
        <table class="table table-sm table-striped">
            <thead>
                <th (click)="sortby('code_societe')">Code EBP</th>
                <th (click)="sortby('nom_societe')">Nom de la société</th>
                <th (click)="sortby('role_societe')">Rôle de la personne</th>
            </thead>
            <tbody>
                <tr>
                    <td>C0000176</td>
                    <td>ILMA SARL</td>
                    <td>Propriétaire</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-sm-4 view-item">
        <div class="row justify-content-between">
            <h5>Groupe(s)</h5>
            <button class="btn btn-outline-info">Gérer les groupes</button><button class="btn btn-outline-info">Ajouter
                à un groupe</button>
        </div>
        <table class="table table-sm table-striped">
            <thead>
                <th (click)="sortby('nom_groupe')">Nom du groupe</th>
                <th class="material-icons">edit</th>
                <th class="material-icons">clear</th>
            </thead>
            <tbody>
                <tr>
                    <td>Aucun élément à afficher ...</td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-100 view-item">
        <h5>Absorber les propriétés d'une autre personne</h5>
        <p class="w-100">
            Cet outil a pour objectif d'assurer la fusion de deux personnes. Toutes les propriétés sont conservées,
            <span>sauf civilité, nom et prénom</span>, de la personne absorbée.
        </p>
        <div class="form-group row">
            <label for="absorber" class="col-sm-2">Personne à absorber : </label>
            <input type="text" class="form-control col-sm-2" id="absorber" name="absorber">
            <div class="col-sm-6"></div>
            <div class="col-sm-2">
                <button class="btn btn-outline-info btn-block">Absorber</button>
            </div>
        </div>
    </div>
</div>